const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_USEFUL_DOCUMENTS":
            return initialState;

        case "USEFUL_DOCUMENTS_RETRIEVED":
            return action.usefulDocs;

        default:
            return state;
    }
}
